import {
    Box,
    Button,
    Grid,
    makeStyles,
    TextField,
} from "@material-ui/core";
import {Close} from "@material-ui/icons";
import React from "react";
import {
    Controller,
    useFieldArray,
    useWatch
} from "react-hook-form";
import AddCircleIcon from "@material-ui/icons/AddCircle";

const creditsDefaultValue = {
    title: "",
    name: "",
};

const useStyles = makeStyles((theme) => ({
    creditsBlk: {
        background: "#FFFFFF",
        marginBottom: "20px",
    },
    creditsBlkHeader: {
        background: "#EDEEF0",
        borderLeft: "3px solid #9D3030",
        fontWeight: "bold",
        fontSize: "14px",
        lineHeight: "16px",
        padding: "12px 13px",
    },
    creditsBlkBody: {
        border: "1px solid #CCCCCC",
        borderTop: "0px",
        padding: "20px 13px",
    },
    deleteBtn: {
        margin: "0",
        padding: "0",
        minWidth: "initial",
    },
    input: {
        width: "100%",
        "& button": {
            fontSize: "13px",
            lineHeight: "15px",
        },
    },
}));

const CreditBlock = ({
                         control,
                         index,
                         classes,
                         disabled,
                         remove,
                         data,
                         dataTc,
                         setValue,
                     }) => {
    const creditEn = useWatch({
        control,
        name: `localizations.en.credit.credit[${index}]`,
    });
    const creditTc = useWatch({
        control,
        name: `localizations.tc.credit.credit[${index}]`,
    });

    return (
        <>
            <Grid
                container
                className={classes.creditsBlkHeader}
                xs={12}
                alignItems="center"
                justify="space-between"
            >
                <span>Selected Credit {index + 1}</span>
                {disabled || (
                    <Button className={classes.deleteBtn}
                            onClick={() => remove(index)}>
                        <Close style={{
                            fontSize: "14px",
                            lineHeight: "16px"
                        }}/>
                    </Button>
                )}
            </Grid>
            <Box className={classes.creditsBlkBody}>
                <Grid container spacing={3}
                      direction="column">
                    <Grid container item xs={12}>
                        <Grid item xs={6}>
                            <Controller
                                defaultValue={data?.title}
                                name={`localizations.en.credit.credit[${index}].title`}
                                control={control}
                                render={({
                                             field: {
                                                 value,
                                                 onChange,
                                                 ...rest
                                             },
                                             fieldState: {error},
                                         }) => (
                                    <TextField
                                        label="Title (English)"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        value={value}
                                        onChange={(event) => {
                                            setValue(`localizations.en.credit.credit[${index}].title`, event.target.value);
                                        }}
                                        {...rest}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <Controller
                                defaultValue={dataTc?.title}
                                name={`localizations.tc.credit.credit[${index}].title`}
                                control={control}
                                render={({
                                             field: {
                                                 value,
                                                 onChange,
                                                 ...rest
                                             },
                                             fieldState: {error},
                                         }) => (
                                    <TextField
                                        label="Title (Traditional Chinese)"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        value={value}
                                        onChange={(event) => {
                                            setValue(`localizations.tc.credit.credit[${index}].title`, event.target.value);
                                        }}
                                        {...rest}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>

                    <Grid container item xs={12}>
                        <Grid item xs={6}>
                            <Controller
                                defaultValue={data?.name}
                                name={`localizations.en.credit.credit[${index}].name`}
                                control={control}
                                render={({
                                             field: {
                                                 value,
                                                 onChange,
                                                 ...rest
                                             },
                                             fieldState: {error},
                                         }) => (
                                    <TextField
                                        label="Name (English)"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        value={value}
                                        onChange={(event) => {
                                            setValue(`localizations.en.credit.credit[${index}].name`, event.target.value);
                                        }}
                                        {...rest}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <Controller
                                defaultValue={dataTc?.name}
                                name={`localizations.tc.credit.credit[${index}].name`}
                                control={control}
                                render={({
                                             field: {
                                                 value,
                                                 onChange,
                                                 ...rest
                                             },
                                             fieldState: {error},
                                         }) => (
                                    <TextField
                                        label="Name (Traditional Chinese)"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        value={value}
                                        onChange={(event) => {
                                            setValue(`localizations.tc.credit.credit[${index}].name`, event.target.value);
                                        }}
                                        {...rest}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>

                </Grid>
            </Box>
        </>
    );
};

export default function CreditSections(props) {
    const {
        control,
        setValue,
        disabled,
    } = props;

    const classes = useStyles();

    const {fields, append, remove} = useFieldArray({
        control,
        name: "localizations.en.credit.credit"
    })

    const {fields: fieldsTc, append: appendTc, remove: removeTc} = useFieldArray({
        control,
        name: "localizations.tc.credit.credit"
    })

    const removeCredit = (index) => {
        remove(index);
        removeTc(index);
    }

    return (
        <>
            {fields.map((data, index) => (
                <div className={classes.creditsBlk}
                     key={data.id}>
                    <CreditBlock
                        {...{
                            control,
                            index,
                            classes,
                            disabled,
                            remove: removeCredit,
                            data,
                            dataTc: fieldsTc[index],
                            setValue,
                        }}
                    />
                </div>
            ))}
            {disabled || (
                <Button
                    type="button"
                    onClick={() => {
                        append(creditsDefaultValue);
                        appendTc(creditsDefaultValue);
                    }}
                    style={{
                        color: "#306F9D",
                        margin: "5px 0",
                    }}
                >
                    <AddCircleIcon/>
                    Add Credit
                </Button>
            )}
        </>
    );
}